import $ from "/home/betapress2/domains/betapress.nl/public_html/htdocs/wp-content/plugins/wp-soup-framework/node_modules/jquery";

$(document).ready(function() {
    //
});
